import Attribute from "./Attribute";
import EntityType from "./EntityType";
import EntityDefinitions from "../App/EntityDefinitions";

class MultiRefAttribute extends Attribute {
    constructor(name, def) {
        super(name, def);
        this.type = 'multiref';
        this.subtype = def.type.refType;
        this.definition = def.type.definition;
        this.values = def.type.values;
    }

    fromJson(data) {
        if (data === null || typeof data !== 'object') {
            return data;
        }

        if (!Array.isArray(data)) {
            data = [data];
        }

        for (let i=0; i<data.length; i++) {
            if (typeof data[i] !== 'object') {
                return data;
            }
        }
        if (!this.definition && !EntityDefinitions.getDefinition(this.subtype)) {
            return data;
        }
        const et = new EntityType(this.definition || EntityDefinitions.getDefinition(this.subtype));
        return data.map(e => et.createEntity(e));
    }

    toJson(value) {
        if (value === null) {
            return value;
        }
        if (!Array.isArray(value)) {
            value = [value];
        }
        return value.map(v => typeof v === 'object' ?  v.id : v);
    }
}

export default MultiRefAttribute;